module.exports = __webpack_public_path__ + "static/media/19.c7931aa4.jpg";